import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { PoolID } from '~src/settings/dataconnect-settings/sections/types/PoolID';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasEdgePoolError } from '../../sections/types/BaasEdgePoolError';

export interface IDeleteBaasClusterParams {
  poolId: PoolID;
  clusterId: string;
}

export interface IDeleteBaasClusterResult extends IResult {
  success?: {
    clusterId: PoolID;
  };
  error?: BaasEdgePoolError;
}

export class DeleteBaasClusterRequest extends Request<IDeleteBaasClusterParams, IDeleteBaasClusterResult> {
  constructor(params: IDeleteBaasClusterParams) {
    super('deleteBaasCluster', params);
  }
}
